// Imports: local files.
import ApiClient from '../../services/ApiClient';
import { showSnackbar, dispatchLoading, dispatchSuccess, dispatchError, getAxiosError } from '../../utils/redux';

// Name of property to be used in reducer data.
const toolsName = 'tools';
const toolName = 'tool';

// Action Types: Get All Tools.
export const GET_TOOLS_START = 'GET_TOOLS_START';
export const GET_TOOLS_SUCCESS = 'GET_TOOLS_SUCCESS';
export const GET_TOOLS_FAILED = 'GET_TOOLS_FAILED';
export const GET_TOOLS_RESET = 'GET_TOOLS_RESET';

// Action Types: Get All Parent Tools.
export const GET_PARENT_TOOLS_START = 'GET_PARENT_TOOLS_START';
export const GET_PARENT_TOOLS_SUCCESS = 'GET_PARENT_TOOLS_SUCCESS';
export const GET_PARENT_TOOLS_FAILED = 'GET_PARENT_TOOLS_FAILED';
export const GET_PARENT_TOOLS_RESET = 'GET_PARENT_TOOLS_RESET';

// Action Types: Get One Tool.
export const GET_TOOL_START = 'GET_TOOL_START';
export const GET_TOOL_SUCCESS = 'GET_TOOL_SUCCESS';
export const GET_TOOL_FAILED = 'GET_TOOL_FAILED';
export const GET_TOOL_RESET = 'GET_TOOL_RESET';

// Action Types: Create Tool.
export const CREATE_TOOL_START = 'CREATE_TOOL_START';
export const CREATE_TOOL_SUCCESS = 'CREATE_TOOL_SUCCESS';
export const CREATE_TOOL_FAILED = 'CREATE_TOOL_FAILED';
export const CREATE_TOOL_RESET = 'CREATE_TOOL_RESET';

// Action Types: Update Tool.
export const UPDATE_TOOL_START = 'UPDATE_TOOL_START';
export const UPDATE_TOOL_SUCCESS = 'UPDATE_TOOL_SUCCESS';
export const UPDATE_TOOL_FAILED = 'UPDATE_TOOL_FAILED';
export const UPDATE_TOOL_RESET = 'UPDATE_TOOL_RESET';

// Action Types: Filter Tools.
export const FILTER_TOOLS_START = 'FILTER_TOOLS_START';
export const FILTER_TOOLS_SUCCESS = 'FILTER_TOOLS_SUCCESS';
export const FILTER_TOOLS_FAILED = 'FILTER_TOOLS_FAILED';
export const FILTER_TOOLS_RESET = 'FILTER_TOOLS_RESET';

// Action Types: Delete Tool.
export const DELETE_TOOL_START = 'DELETE_TOOL_START';
export const DELETE_TOOL_SUCCESS = 'DELETE_TOOL_SUCCESS';
export const DELETE_TOOL_FAILED = 'DELETE_TOOL_FAILED';
export const DELETE_TOOL_RESET = 'DELETE_TOOL_RESET';

// Action Creators: Get All Tools.
const getToolsStart = (payload) => ({ type: GET_TOOLS_START, payload });
const getToolsSuccess = (payload) => ({ type: GET_TOOLS_SUCCESS, payload });
const getToolsFailed = (payload) => ({ type: GET_TOOLS_FAILED, payload });
const getToolsReset = () => ({ type: GET_TOOLS_RESET });

// Action Creators: Get All Parent Tools.
const getParentToolsStart = (payload) => ({ type: GET_PARENT_TOOLS_START, payload });
const getParentToolsSuccess = (payload) => ({ type: GET_PARENT_TOOLS_SUCCESS, payload });
const getParentToolsFailed = (payload) => ({ type: GET_PARENT_TOOLS_FAILED, payload });
const getParentToolsReset = () => ({ type: GET_PARENT_TOOLS_RESET });

// Action Creators: Get One Tool.
const getToolStart = (payload) => ({ type: GET_TOOL_START, payload });
const getToolSuccess = (payload) => ({ type: GET_TOOL_SUCCESS, payload });
const getToolFailed = (payload) => ({ type: GET_TOOL_FAILED, payload });
const getToolReset = () => ({ type: GET_TOOL_RESET });

// Action Creators: Create Tool.
const createToolStart = (payload) => ({ type: CREATE_TOOL_START, payload });
const createToolSuccess = (payload) => ({ type: CREATE_TOOL_SUCCESS, payload });
const createToolFailed = (payload) => ({ type: CREATE_TOOL_FAILED, payload });
const createToolReset = () => ({ type: CREATE_TOOL_RESET });

// Action Creators: Update Tool.
const updateToolStart = (payload) => ({ type: UPDATE_TOOL_START, payload });
const updateToolSuccess = (payload) => ({ type: UPDATE_TOOL_SUCCESS, payload });
const updateToolFailed = (payload) => ({ type: UPDATE_TOOL_FAILED, payload });
const updateToolReset = () => ({ type: UPDATE_TOOL_RESET });

// Action Creators: Filter Tools.
const filterToolsStart = (payload) => ({ type: FILTER_TOOLS_START, payload });
const filterToolsSuccess = (payload) => ({ type: FILTER_TOOLS_SUCCESS, payload });
const filterToolsFailed = (payload) => ({ type: FILTER_TOOLS_FAILED, payload });
const filterToolsReset = () => ({ type: FILTER_TOOLS_RESET });

// Action Creators: Delete Tool.
const deleteToolStart = (payload) => ({ type: DELETE_TOOL_START, payload });
const deleteToolSuccess = (payload) => ({ type: DELETE_TOOL_SUCCESS, payload });
const deleteToolFailed = (payload) => ({ type: DELETE_TOOL_FAILED, payload });
const deleteToolReset = () => ({ type: DELETE_TOOL_RESET });

// Actions: Get All Tools.
export const getTools = (payload, options = {}) => {
  const { page, limit, pagination, toolName, noParentsTool, parentTool, manufacturerId } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, getToolsStart);

      const query = { page, limit, pagination, toolName, noParentsTool, parentTool, manufacturerId };
      const result = await ApiClient.get('/tools', { params: query });
      if (result.data?.success) {
        const { tools } = result.data?.data;
        dispatchSuccess(dispatch, getToolsSuccess, tools, toolsName);
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, getToolsFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, getToolsFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Get All Tools.
export const clearTools = () => getToolsReset();

export const getParentTools = (payload, options = {}) => {
  const { page, limit, pagination, name, noParentsTool, parentTool, manufacturerId } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, getParentToolsStart);

      const query = { page, limit, pagination: false, name, noParentsTool, parentTool, manufacturerId };
      const result = await ApiClient.get('/tools', { params: query });
      if (result.data?.success) {
        const { tools } = result.data?.data;
        dispatchSuccess(dispatch, getParentToolsSuccess, tools, toolsName);
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, getParentToolsFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, getParentToolsFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Get All Parent Tools.
export const clearParentTools = () => getParentToolsReset();

// Actions: Get One Tool.
export const getTool = (payload, options = {}) => {
  const { toolId } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, getToolStart);

      const result = await ApiClient.get(`/tools/${toolId}`);
      if (result.data?.success) {
        const { tool } = result.data?.data;
        dispatchSuccess(dispatch, getToolSuccess, tool, toolName);
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, getToolFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, getToolFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Get One Tool.
export const clearTool = () => getToolReset();

// Actions: Create Tool.
export const createTool = (payload, options = {}) => {
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, createToolStart);

      const fields = [
        'name',
        'application',
        'tipsTricks',
        'miscellaneous',
        'details',
        'manufacturer',
        'levelOne',
        'levelTwo',
        'levelThree',
        'photo',
        'video',
      ];
      const formData = new FormData();
      fields.forEach((field) => payload[field] && formData.append(field, payload[field]));

      const result = await ApiClient.post(`/tools`, formData);
      if (result.data?.success) {
        const { tool } = result.data?.data;
        dispatchSuccess(dispatch, createToolSuccess, tool, toolName);
        showSnackbar(dispatch, 'Tool created successfully!', 'success');
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, createToolFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, createToolFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Created Tool.
export const clearCreatedTool = () => createToolReset();

// Actions: Update Tool.
export const updateTool = (payload, options = {}) => {
  const { toolId } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, updateToolStart);

      const fields = [
        'name',
        'application',
        'tipsTricks',
        'miscellaneous',
        'details',
        'manufacturer',
        'levelOne',
        'levelTwo',
        'levelThree',
        'photo',
        'video',
        'toBeDeleted',
      ];
      const formData = new FormData();
      fields.forEach((field) => payload[field] && formData.append(field, payload[field]));

      const result = await ApiClient.put(`/tools/${toolId}`, formData);
      if (result.data?.success) {
        const { tool } = result.data?.data;
        dispatchSuccess(dispatch, updateToolSuccess, tool, toolName);
        showSnackbar(dispatch, 'Tool updated successfully!', 'success');
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, updateToolFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, updateToolFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Updated Tool.
export const clearUpdatedTool = () => updateToolReset();

// Actions: Filter Tools.
export const filterTools = (payload, options = {}) => {
  const { toolId, manufacturerId } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, filterToolsStart);

      const result = await ApiClient.get(`/tools/filterTools/${toolId}`, { params: { manufacturerId } });
      if (result.data?.success) {
        const { toolsOfChoosenParent } = result.data?.data;
        dispatchSuccess(dispatch, filterToolsSuccess, toolsOfChoosenParent, 'toolsOfChoosenParent');
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, filterToolsFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, filterToolsFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Filtered Tools.
export const clearFilteredTools = () => filterToolsReset();

// Actions: Delete Tool.
export const deleteTool = (payload, options = {}) => {
  const { toolId } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, deleteToolStart);

      const result = await ApiClient.delete(`/tools/${toolId}`);
      if (result.data?.success) {
        const { tool } = result.data?.data;
        dispatchSuccess(dispatch, deleteToolSuccess, tool, toolName);
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, deleteToolFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, deleteToolFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Deleted Tool.
export const clearDeletedTool = () => deleteToolReset();
